module.exports = {
  '@primary-color': '#DF3338',
  '@link-color': '#DE3B3C',
  '@redMain': '#DF3338',
  '@greyDark': '#045454',
};
